(() => {
  if (window.__csCartReady) return;
  window.__csCartReady = true;

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-cs-cart]').forEach((drawer) => {
      if (drawer.dataset.csCartReady) return;
      drawer.dataset.csCartReady = 'true';

      const sync = () => {
        const active = drawer.classList.contains('active');
        drawer.dataset.csCartState = active ? 'open' : 'closed';
        if (active) drawer.querySelector('.drawer__inner')?.setAttribute('aria-busy', 'false');
      };

      const observer = new MutationObserver(sync);
      observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      drawer.__csCartObserver = observer;
      sync();

      drawer.addEventListener('click', (event) => {
        const checkout = event.target.closest('#CartDrawer-Checkout');
        if (!checkout || checkout.disabled) return;
        if (checkout.dataset.csSubmitting === 'true') {
          event.preventDefault();
          return;
        }
        checkout.dataset.csSubmitting = 'true';
        checkout.setAttribute('aria-busy', 'true');
        window.setTimeout(() => {
          delete checkout.dataset.csSubmitting;
          checkout.removeAttribute('aria-busy');
        }, 4000);
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-cs-cart]').forEach((drawer) => drawer.__csCartObserver?.disconnect());
  });
})();

/* Corsaille: a single acknowledgement after a confirmed cart addition. */
(() => {
  if (window.CorsailleCartAddFeedback20260929) return;

  const handled = new WeakSet();
  let activeMotion = null;

  const cancelMotion = () => {
    activeMotion?.cancel();
    activeMotion = null;
  };

  document.addEventListener('visibilitychange', () => { if (document.hidden) cancelMotion(); });

  const confirmedCount = (payload) => {
    if (Number.isSafeInteger(payload.item_count) && payload.item_count >= 0) return payload.item_count;
    const html = payload.sections?.['cart-icon-bubble'];
    if (typeof html !== 'string') return null;
    const serverIcon = new DOMParser().parseFromString(html, 'text/html');
    const text = serverIcon.querySelector('[data-corsaille-cart-count-text], [data-corsaille-cart-count]')?.textContent?.trim();
    if (!text || !/^\d+$/.test(text)) return null;
    const count = Number(text);
    return Number.isSafeInteger(count) ? count : null;
  };

  const updateCount = (link, payload) => {
    const count = confirmedCount(payload);
    if (count === null) return;
    link.querySelectorAll('[data-corsaille-cart-count-text], [data-corsaille-cart-count]').forEach((node) => {
      if (node.textContent !== String(count)) node.textContent = String(count);
    });
    link.querySelector('[data-corsaille-cart-count]')?.classList.toggle('is-empty', count === 0);
    const live = link.querySelector('[data-corsaille-cart-live]');
    const label = count === 1 ? 'Coș, 1 produs' : `Coș, ${count} produse`;
    if (live && live.textContent !== label) live.textContent = label;
  };

  window.CorsailleCartAddFeedback20260929 = {
    added(payload) {
      try {
        if (!payload || typeof payload !== 'object' || payload.status || payload.errors || handled.has(payload)) return;
        handled.add(payload);
        const link = document.getElementById('cart-icon-bubble');
        if (!link) return;
        updateCount(link, payload);
        if (document.hidden) return;
        const icon = link.querySelector('svg.cs-icon');
        if (!icon?.animate) return;

        // Continue from the visible position on rapid consecutive successes.
        const from = getComputedStyle(icon).transform;
        cancelMotion();
        const base = getComputedStyle(icon).transform;
        const prefix = base === 'none' ? '' : `${base} `;
        const easing = 'cubic-bezier(0.23, 1, 0.32, 1)';
        const motion = icon.animate([
          { transform: from, offset: 0, easing },
          { transform: `${prefix}translateY(-2.5px) rotate(-4deg)`, offset: 0.4, easing },
          { transform: `${prefix}translateY(0.5px) rotate(0.75deg)`, offset: 0.76, easing },
          { transform: base, offset: 1 }
        ], { duration: 280, iterations: 1, fill: 'none' });
        activeMotion = motion;
        const clear = () => { if (activeMotion === motion) activeMotion = null; };
        motion.finished.then(clear, clear);
      } catch (_) {
        // Optional feedback must never change a successful purchase into an error.
      }
    }
  };
})();
